var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopRail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 22,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7C8 5.89543 8.89543 5 10 5H22C23.1046 5 24 5.89543 24 7V19C24 20.1046 23.1046 21 22 21H10C8.89543 21 8 20.1046 8 19V7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.74 19.2V18.36H19V19.2H13.04V18.36H12.28V19.2H11.36C11.14 19.2 10.96 19.38 10.96 19.58C10.96 19.8 11.14 19.98 11.36 19.98H20.68C20.9 19.98 21.06 19.8 21.06 19.58C21.06 19.38 20.9 19.2 20.68 19.2H19.74ZM21.22 8.65999C20.86 7.89999 20.58 7.29999 20.28 7.03999C19.84 6.63999 17.94 6.17999 16 6.17999C14.12 6.17999 12.18 6.63999 11.76 7.03999C11.46 7.29999 11.16 7.89999 10.8 8.65999C10.5 9.31999 10.26 9.93999 10.26 10.3V16.08C10.26 16.54 10.42 16.74 11.04 17.22C11.5 17.58 11.7 17.74 12.4 17.74H13.72V18.6H18.34V17.74H19.64C20.34 17.74 20.54 17.58 20.98 17.22C21.6 16.72 21.74 16.54 21.74 16.08V10.3C21.74 9.93999 21.5 9.31999 21.22 8.65999ZM19.04 7.73999V8.07999C19.04 8.33999 18.84 8.55999 18.58 8.55999H13.46C13.2 8.55999 12.98 8.33999 12.98 8.07999V7.73999H19.04ZM13.46 16.66C13.18 16.66 12.98 16.46 12.98 16.18C12.98 15.9 13.18 15.68 13.46 15.68C13.74 15.68 13.98 15.9 13.98 16.18C13.98 16.46 13.74 16.66 13.46 16.66ZM18.58 16.6C18.3 16.6 18.08 16.4 18.08 16.12C18.08 15.84 18.3 15.62 18.58 15.62C18.86 15.62 19.08 15.84 19.08 16.12C19.08 16.4 18.86 16.6 18.58 16.6ZM19.32 14.1C19.26 14.44 18.92 14.7 18.58 14.7H13.46C13.12 14.7 12.78 14.44 12.72 14.1L11.78 10.12C11.72 9.77999 11.94 9.51999 12.28 9.51999H19.74C20.08 9.51999 20.32 9.77999 20.24 10.12L19.32 14.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopRail);
export default __webpack_public_path__ + "static/media/stop-rail.1f29339fca53a541ebee4e80ca79c901.svg";
export { ForwardRef as ReactComponent };